import React, { useState } from 'react';
import { Icons, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import CarDTO from '../../../../dto/CarDTO';
import Switches from '../../../../components/fields/Switches/Switches';
import CustomSelectInput from '../../../../components/fields/SelectInput/CustomSelectInput';
import {
  ECOLOGY_CLASS_TYPE_LIST, OWNERSHIP_TYPE, OWNERSHIP_TYPE_LIST, PROCEDURE_TYPE, USER_TYPE,
} from '../../../../configs';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import FileInput from '../../../../components/fields/FileInput/FileInput';
import {
  grzTransliterationTransform,
  toLowerCase,
} from '../../../../utils/utils';

export default function CarForm(props) {
  const {
    prefix, disabled, control, selectedProcedure, formMeta, watch, getValues, federal_law_number,
  } = props;
  const dto = new CarDTO({ procedure: selectedProcedure, federal_law_number });
  const attributes = dto.getAttributesByName();
  const [ownership_type, setOwnershipType] = useState(false);

  React.useEffect(() => {
    const subscription = watch(values => {
      if (getValues(`${prefix}ownership_type`) === OWNERSHIP_TYPE.OWNER) {
        setOwnershipType(getValues(`${prefix}ownership_type`));
        return;
      }
      setOwnershipType('');
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <>
      <Row className="row-cols-3">
        <FieldDTOWithCol
          control={control}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_brand}
          variant="material"
          namePrefix={prefix}
          disabled={disabled}
          formMeta={formMeta}
        />
        <FieldDTOWithCol
          control={control}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_model}
          variant="material"
          namePrefix={prefix}
          disabled={disabled}
          formMeta={formMeta}
        />
        <FieldDTOWithCol
          control={control}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_lpn}
          transform={grzTransliterationTransform}
          variant="material"
          namePrefix={prefix}
          disabled={disabled}
          formMeta={formMeta}
        />
      </Row>
      <Row className="row-cols-3">
        <FieldDTOWithCol
          control={control}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_vin}
          variant="material"
          namePrefix={prefix}
          disabled={disabled}
          afterContent={<Icons customIcon className="move-icon" width={24} height={24} icon="move-icon" />}
          formMeta={formMeta}
        />
        {selectedProcedure === PROCEDURE_TYPE.PROCEDURE_kt_exlt
          ? (
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.applicant_car_cd_file}
              variant="material"
              namePrefix="media."
              multiple
            />
          )
          : null }
        {selectedProcedure !== PROCEDURE_TYPE.PROCEDURE_kt_exlt
          ? (
            <>
              <FieldDTOWithCol
                control={control}
                type="text"
                component={CustomSelectInput}
                dtoObject={attributes.vehicle_year}
                variant="material"
                options={Array.from({ length: new Date().getFullYear() - 1899 }, (_, i) => ({
                  value: new Date().getFullYear() - i,
                  name: `${new Date().getFullYear() - i}`,
                }))}
                namePrefix={prefix}
                withLabel
                disabled={disabled}
                formMeta={formMeta}
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                dtoObject={attributes.vehicle_color}
                variant="material"
                namePrefix={prefix}
                disabled={disabled}
                component={CustomSelectInput}
                withLabel
                transform={toLowerCase}
                options={[{ value: '', name: ' ' }, { value: 'белый', name: 'Белый' }, { value: 'не белый', name: 'Не Белый' }, { value: 'не заполнено', name: 'Не заполнено' }]}
                formMeta={formMeta}
              />
            </>
          ) : null }
      </Row>
      {selectedProcedure !== PROCEDURE_TYPE.PROCEDURE_kt_exlt ? (
        <>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={CustomSelectInput}
              dtoObject={attributes.ecology_class}
              variant="material"
              namePrefix={prefix}
              disabled={disabled}
              withLabel
              options={ECOLOGY_CLASS_TYPE_LIST}
              formMeta={formMeta}
            />
          </Row>
          <div className="f4 mt-3">Сведения о СТС</div>
          <Row className="row-cols-2">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.vehicle_registration_number}
              variant="material"
              namePrefix={prefix}
              disabled={disabled || selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_8}
              formMeta={formMeta}
            />
            <FieldDTOWithCol
              control={control}
              type="text"
              component={DateTimePicker}
              hideTime
              changeFormat="YYYY-MM-DD"
              withLabel
              dtoObject={attributes.vehicle_registration_issue_date}
              variant="material"
              namePrefix={prefix}
              disabled={disabled || selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_8}
              formMeta={formMeta}
            />
          </Row>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={Switches}
              dtoObject={attributes.has_special_lifting_device}
              variant="material"
              namePrefix={prefix}
              disabled={disabled}
              withLabel
              formMeta={formMeta}
            />
          </Row>
          <Row className="row-cols-3">
            <FieldDTOWithCol
              control={control}
              component={CustomSelectInput}
              dtoObject={attributes.ownership_type}
              variant="material"
              namePrefix={prefix}
              disabled={disabled || selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_8}
              withLabel
              options={OWNERSHIP_TYPE_LIST}
              formMeta={formMeta}
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.applicant_car_cd_file}
              variant="material"
              namePrefix="media."
              multiple
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.car_photo_file}
              variant="material"
              namePrefix="media."
              textarea
              multiple
            />
          </Row>
          <div className="f4 mt-3">Информация о договоре</div>
          <Row className="row-cols-3">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={TextInputWithLabel}
              dtoObject={
                ownership_type
                  ? {
                    ...attributes.ownership_contract_number,
                    validators: [],
                  }
                  : attributes.ownership_contract_number
              }
              variant="material"
              namePrefix={prefix}
              disabled={disabled || (selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_8)}
              withLabel
              formMeta={formMeta}
            />
            <FieldDTOWithCol
              control={control}
              type="text"
              component={DateTimePicker}
              hideTime
              changeFormat="YYYY-MM-DD"
              variant="material"
              dtoObject={
                ownership_type
                  ? {
                    ...attributes.ownership_contract_effective_date,
                    validators: [],
                  }
                  : attributes.ownership_contract_effective_date
              }
              namePrefix={prefix}
              disabled={disabled || (selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_8)}
              withLabel
              formMeta={formMeta}
            />
            <FieldDTOWithCol
              control={control}
              type="text"
              component={DateTimePicker}
              hideTime
              changeFormat="YYYY-MM-DD"
              variant="material"
              dtoObject={
                ownership_type
                  ? {
                    ...attributes.ownership_contract_expiration_date,
                    validators: [],
                  }
                  : attributes.ownership_contract_expiration_date
              }
              namePrefix={prefix}
              disabled={disabled || (selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_8)}
              withLabel
              formMeta={formMeta}
            />
          </Row>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.ownership_contract_files}
              variant="material"
              namePrefix="media."
              textarea
              multiple
            />
          </Row>
        </>
      ) : null}
    </>
  );
}
